import { React, Suspense, useEffect, useState } from "react";
import { useAlertContext, useEventsContext } from "src/hooks/use-alert";
import "./AssetDetail.css";
import { Grid } from "@mui/material";
import AssetForm from "src/components/AssetDetails/AssetForm";
import ButtonPolicy from "src/components/Permission/ButtonPolicy";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import { getAsset } from "src/apis/complex";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  useNavigate,
  useRouteLoaderData,
  defer,
  Await,
} from "react-router-dom";
import { useParams } from "react-router-dom";
import { getBuilding } from "src/apis/complex";
import ItemUseForm from "src/components/Forms/ItemUseForm";
import DailogContainer from "src/components/DailogContainer";
import { deleteItem } from "src/apis/item";
import { getAssetImg } from "src/apis/ConfigureAsset3d";
import VisualizeAsset2d from "src/components/VisualizeAsset2d/VisualizeAsset2d";
import UpdateImageForm from "../../components/Asset2dImage/UpdateAssetConfiguration";
import ErrorPage from "src/pages/ErrorPages/ErrorPage";
export default function BuildingOffice() {
  const alert = useAlertContext();
  const { events } = useEventsContext();
  const [alerts, setAlerts] = useState([]);


  /** ____Asset information loading and setting __________**/
  const [items, setItems] = useState([]); 
  const { buildingId, assetId } = useParams();
  const data = useRouteLoaderData("asset-detail");
  const navigate = useNavigate();
  useEffect(() => {
    if (data.asset[0] && data.asset[0].items) {
      setItems(data.asset[0].items);
    }
  }, [data.asset]);

  /**______End______________ */

  /*_____________States and functions for Sensor data monitoring_________________ */
  const [itemsValue, setItemValues] = useState([]);
  var x = itemsValue;
  useEffect(() => {
    setAlerts(events.data);
  }, [events.data]);

  if (x.length !== 0) {
    var y = x.map((item) => {
      if (!item.hasOwnProperty("valueWithOutUnit")) {
        item.valueWithOutUnit = item.lastRegisteredValue;
      }
      if (
        alerts.find((x) => x.title === item.serialNumber) !== undefined &&
        alerts.find((x) => x.title === item.serialNumber).valueWithOutUnit !==
          item.valueWithOutUnit
      ) {
        item.valueWithOutUnit = alerts.find(
          (x) => x.title === item.serialNumber
        ).valueWithOutUnit;
      } else if (
        alerts.find((x) => x.title === item.serialNumber) !== undefined
      ) {
      }
      return item;
    });
    if (y.toString() !== x.toString()) {
      setItemValues(y);
    }
  }
  /*_______End of Sensor data monitoring ________ */


  /**__________States and Functions for Asset2D Visualization and its update______________ **/

  const [showUpdateAssetImg, setShowUpdateAssetImg] = useState({
    show: false,
    updateVisualizeAsset: false,
  });
  const [configurationDataForUpdate, setConfigurationDataForUpdate] =
    useState(null);
  {
    /**open update asset img  dialog*/
  }
  const handleUpdateConfigure = () => {
    setShowUpdateAssetImg({ show: true, updateVisualizeAsset: false });
  };
  {
    /* callback function passed to visualizeAsset to  make its loaded data visible here for other components */
  }
  const SetDataForUpdate = (data) => {
    setConfigurationDataForUpdate(data);
  };
  {
    /* callback function passed tovisualizeAsset and UpdateAssetImge to synchronize reload after an update  */
  }
  const closeUpdateAssetImg = (showForm, updateVisualizer) => {
    setShowUpdateAssetImg({
      show: showForm,
      updateVisualizeAsset: updateVisualizer,
    });
  };

  /**__________End of Asset2D Visualization ______________ **/


  /**_____________States and functions for CRUD Methods/Form handling _________________ **/
  
  const [selectedItem, setSelectedItem] = useState(null);
  const [isEditItem, setIsEditItem] = useState(false);
  const [editItem, setEditItem] = useState("");
  const [deleteDetailOpen, setDeleteDetailOpen] = useState(false);
  const [deleteItemInfo, setDeleteItemInfo] = useState("");
  const [deleteText, setDeleteText] = useState("");
  const [modal, setModal] = useState({ open: false, formElement: null });
  const [externalSubmit, setExternalSubmit] = useState(false);
  const handleExternalSubmit = (submitting, closeModal = false) => {
    if (submitting) {
      setExternalSubmit(true);
      handleClose();
    } else {
      if (closeModal) {
        handleClose();
        navigate();
      }
      setExternalSubmit(false);
    }
  };
  const handleDeleteItem = (id) => {
    setDeleteDetailOpen(true);
    setDeleteItemInfo(id);
    setDeleteText("Are you sure you want to delete this item?");
  };
  // Callback function to confirm the delete in child component
  const handleConfirmChange = () => {
    handleConfirmDelete();
  };
  const handleConfirmDelete = async () => {
    try {
      const response = await deleteItem(deleteItemInfo);
      if (response.success === true) {
        // Remove the deleted item from the items list
        setItems((prevAssets) =>
          prevAssets.filter((item) => item.id !== deleteItemInfo)
        );
        alert.setSuccess((prev) => [
          ...prev,
          {
            status: true,
            message: "Item deleted succesfully",
            index: prev.length,
          },
        ]);
      } else {
        alert.setError((prev) => [
          ...prev,
          {
            status: true,
            messages: "Deletion not succesfull",
            index: prev.length,
          },
        ]);
      }
    } catch (error) {
      console.error("Error deleting item:", error);
      alert.setError((prev) => [
        ...prev,
        {
          status: true,
          messages: "Error deleting item",
          index: prev.length,
        },
      ]);
    }
    setDeleteDetailOpen(false);
  };
  const handleClickOpen = (form, item) => {
    setModal({ open: true, formElement: form });
    setSelectedItem(item);
  };

  const handleClose = () => {
    setExternalSubmit(false);
    setModal({ open: false, formElement: null });
  };

  const handleEditItemClose = () => {
    setIsEditItem(false);
  };
  const handleEditClick = (item) => {
    setEditItem(item);
    setIsEditItem(true);
  };
  /*_____________End of CRUD Methods/Form handling for_________________ */

  return (
  
    <Suspense
      fallback={
        <p style={{ color: "#FFF", textAlign: "center" }}>Loading...</p>
      }
    >
      <Await resolve={data.asset} errorElement={<ErrorPage />}>
        {(loadedasset) => {
          if(loadedasset[0]){
          if (x.length === 0) {
            setItemValues(loadedasset[0].items);
          }

          const building = loadedasset[1];

          const assetData = {
            id: loadedasset[0].id,
            name: loadedasset[0].name,
            buildingId: building.id,
          };
       
          return (
            <div>
              <div className="Office">
                <div className="started">
                  <h2>{loadedasset[0].name}</h2>
                </div>
                <Grid container spacing={3}>
                  <Grid item md={6} lg={6} sm={12} xs={12}>
                    Inventory : {building.name} - {loadedasset[0].name}
                  </Grid>
                  <Grid item md={2} lg={2} sm={12} xs={12}>
                    <div className="addNewSensorButton">
                      <ButtonPolicy
                        className="updateAssetButton"
                        onClick={() => handleClickOpen("site")}
                        variant="contained"
                        //disabled={roles.roles === "bpu"}
                        sx={{
                          width: 150,
                          borderRadius: "0",
                        }}
                      >
                        Update Asset
                      </ButtonPolicy>
                    </div>
                  </Grid>
                  {configurationDataForUpdate && (
                    <Grid item md={2} lg={2} sm={12} xs={12}>
                      <div className="addNewSensorButton">
                        <ButtonPolicy
                          className="updateConfButton"
                          onClick={handleUpdateConfigure}
                          // disabled={roles.roles !== "adm"}
                          variant="contained"
                          sx={{
                            marginTop: 2,
                            width: 200,
                            borderRadius: "0",
                          }}
                        >
                          Update Configuration
                        </ButtonPolicy>
                      </div>
                    </Grid>
                  )}
                  <Grid item md={2} lg={2} sm={12} xs={12}>
                    <div className="addNewSensorButton">
                      <ButtonPolicy
                        className="addSensorButton"
                        onClick={() => handleClickOpen("item")}
                        // disabled={roles.roles !== "adm"}
                        variant="contained"
                        sx={{
                          marginTop: 2,
                          width: 200,
                          borderRadius: "0",
                        }}
                      >
                        Add a sensor
                      </ButtonPolicy>
                    </div>
                  </Grid>
                </Grid>
                <div className="homeContainerOffice">
                  <Grid container>
                    <Grid item xs={12} lg={6} md={6} sm={12}>
                      <Grid container>
                        {items && items.length && items.map((item, index) => (
                          <Grid item xs={12} sm={12} md={6} lg={6} key={index}>
                            <div className="dangerContainer">
                              <div className="danger">
                                <div className="HeadingOfDanger">
                                  {item.itemType.name}
                                </div>
                                <div className="bodyOfDanger">
                                  <div className="value">
                                    {alerts.find(
                                      (x) => x.title === item.serialNumber
                                    ) !== undefined
                                      ? alerts.find(
                                          (x) => x.title === item.serialNumber
                                        ).valueWithOutUnit
                                      : item.valueWithOutUnit ??
                                        item.lastRegisteredValue}{" "}
                                    {/*item.lastregiseredvalue ??*/}
                                  </div>
                                  <div className="itemFeatures">
                                    <div className={`alarm ${item.alarm}`}>
                                      Serial Number: {item.serialNumber}
                                    </div>
                                    <div className="first">
                                      Critical Threshold:{" "}
                                      {item.thresholdCritical}
                                    </div>
                                    <div className="first">
                                      Medium Threshold: {item.thresholdMedium}
                                    </div>
                                  </div>
                                  <div className="assetDetailActionButtons">
                                    <div className="actionButtonEdit">
                                      <ButtonPolicy className="editIconButton">
                                        <EditIcon
                                          onClick={() => handleEditClick(item)}
                                        />
                                      </ButtonPolicy>
                                    </div>
                                    <div className="actionButtonDelete">
                                      <ButtonPolicy
                                      //disabled={roles.roles !== "adm"}
                                      >
                                        <DeleteIcon
                                          onClick={() =>
                                            handleDeleteItem(item.id)
                                          }
                                        />
                                      </ButtonPolicy>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Grid>
                        ))}
                      </Grid>
                    </Grid>
                    <Grid item md={6}>
                      <VisualizeAsset2d
                        assetId={assetId}
                        items={items}
                        SetDataForUpdate={SetDataForUpdate}
                        updateSelf={showUpdateAssetImg.updateVisualizeAsset}
                        resetUpdateSelf={closeUpdateAssetImg}
                      />
                    </Grid>
                  </Grid>
                </div>
              </div>
              <Dialog open={modal.open} onClose={handleClose}>
                <div className="modalContainer">
                  <div className="modal">
                    <Grid container spacing={3}>
                      <Grid item xs={12}>
                        <DialogContent>
                          <Grid container>
                            {modal.formElement === "item" ? (
                              <div>
                                {/* Create Item form */}
                                <ItemUseForm
                                  type="Create New Item"
                                  handleClose={handleClose}
                                  assetData={assetData}
                                  setItems={setItems}
                                />
                              </div>
                            ) : (
                              <AssetForm
                                props={{
                                  custom: true,
                                  onSubmit: handleExternalSubmit,
                                  externalSubmit: externalSubmit,
                                  updateInfo: {
                                    id: loadedasset[0].id,
                                    name: loadedasset[0].name,
                                    description: loadedasset[0].description,
                                    serialNumber: loadedasset[0].serialNumber,
                                    //protocol: loadedasset[0].protocol,
                                    buildingId: building.id,
                                  },
                                }}
                              />
                            )}
                          </Grid>
                        </DialogContent>
                      </Grid>
                      {modal.formElement !== "item" && (
                        <Grid item md={12} xs={12}>
                          <div className="bottomPart">
                            <DialogActions>
                              <Grid container>
                                <Grid item xs={6} md={6}>
                                  <div className="cancelButton">
                                    <ButtonPolicy
                                      onClick={() => handleClose()}
                                      variant="text"
                                    >
                                      Cancel
                                    </ButtonPolicy>
                                  </div>
                                </Grid>
                                <Grid item xs={6} md={6}>
                                  <div className="addButton">
                                    <ButtonPolicy
                                      variant="text"
                                      onClick={() => handleExternalSubmit(true)}
                                    >
                                      submit
                                    </ButtonPolicy>
                                  </div>
                                </Grid>
                              </Grid>
                            </DialogActions>
                          </div>
                        </Grid>
                      )}
                    </Grid>
                  </div>
                </div>
              </Dialog>
              {/* Edit Item form */}
              <Dialog open={isEditItem} onClose={handleEditItemClose}>
                <DialogContent>
                  <ItemUseForm
                    type="Edit Item"
                    setItems={setItems}
                    handleEditItemClose={handleEditItemClose}
                    editItem={editItem}
                  />
                </DialogContent>
              </Dialog>
              {configurationDataForUpdate && (
                <UpdateImageForm
                  openDialog={showUpdateAssetImg.show}
                  closeDialog={closeUpdateAssetImg}
                  configurationDataWithImage={configurationDataForUpdate}
                  configurationData={data.asset[0]}
                />
              )}
              {/* Delete dailog */}
              {deleteDetailOpen && (
                <DailogContainer
                  detailOpen={deleteDetailOpen}
                  setDetailOpen={setDeleteDetailOpen}
                  text={deleteText}
                  onToggleChange={handleConfirmChange}
                />
              )}
            </div>
          );}
          else{
            return <ErrorPage />
          }
        }}
      </Await>
    </Suspense>
  );
}

async function loadAsset(id, buildId) {
  const response = await getAsset(id);
  const response_2 = await getBuilding(buildId);

  return [response, response_2];
}

//this is the loader function which is imported in the app.js and
//passed to the component where i want in the app.js tree
export async function loader({ request, params }) {
  const id = params.assetId;
  const builId = params.buildingId;

  return defer({
    asset: await loadAsset(id, builId),
  });
}
